import find from '@/utils/find'
import moment from 'moment';

export default {
    // Getters.
    appStatus: state => state.appStatus,
    userId: state => state.userId,
    socketMessage: state => state.socket.message,
    awardedDeviceIds: state => state.awardedDeviceIds,
    geofencesIds: state => state.geofencesIds,
    isHighlightedDevicesView: state => state.isHighlightedDevicesView,
    focusDeviceId: state => state.focusDeviceId,
    markers: state => state.markers,
    selectedClassificationId: state => state.selectedClassificationId,
    selectedSerieNumber: state => state.selectedSerieNumber,
    isLiveMode: state => state.isLiveMode,
    isPlaybackReady: state => state.isPlaybackReady,
    playbackMarkers: state => state.playbackMarkers,
    previousSelectedClassificationId: state =>
        state.previousSelectedClassificationId,
    // Classification id index.
    tracksBounds: state => state.tracksBounds,
    // Entities
    user: state => state.entities.users[state.userId],
    // Getters by id.
    devices: state => state.entities.devices,
    devicesSummary: state => state.entities.devicesSummary,
    positions: state => state.entities.positions,
    trackpoints: state => state.entities.trackpoints,
    competitions: state => state.entities.competitions,
    gpxFiles: state => state.entities.gpxFiles,
    classifications: state => state.entities.classifications,
    locations: state => state.entities.locations,
    players: state => state.entities.players,
    competitionLayouts: state => state.entities.competitionLayouts,
    isShowDistanceMarkers: state => state.isShowDistanceMarkers,
    amountDistanceMarkers: state => state.amountDistanceMarkers,
    listOrderBy: state => state.listOrderBy,
    isRevertDistanceMarkers: state => state.isRevertDistanceMarkers,
    isShowAllNames: state => state.isShowAllNames,
    isShowDeviceTails: state => state.isShowDeviceTails,
    eventTimesData: state => state.eventTimesData,
    // Getters by relation.
    trackpointsBy: state => entity =>
        find(state.entities.trackpoints, entity, false, undefined, true),
    playersBy: state => entity =>
        find(state.entities.players, entity, false, 'deviceId'),
    // Getters for replay

    serieTimes: state => {
        let cls = state.eventTimesData?.classifications?.find(c => c.external_id === state.selectedClassificationId);
        let res = cls.series.find(c => c.number === state.selectedSerieNumber);
        return res
    },
    serieTimesInMs: (_, getters) => {
        const serie = getters.serieTimes

        const newStartTime = moment(serie.series_start, 'YYYY-MM-DD HH:mm:ss').toISOString().slice(0, -1)
        const newEndTime = moment(serie.series_end, 'YYYY-MM-DD HH:mm:ss').toISOString().slice(0, -1)
        const serieStartTime = moment(newStartTime).valueOf();
        const serieEndTime = moment(newEndTime).valueOf();
        // console.log("newStartTime (ms):", newStartTime, nSTinMs, nETinMs);
        return { serieStartTime, serieEndTime }

    }
}
